// src/store/apiSlices/userApiSlice.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './axiosBaseQuery';

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['User'],
  endpoints: (builder) => ({
    getUserProfile: builder.query<any, void>({
      query: () => ({ url: '/user/authorities', method: 'GET' }),
    }),
    updateUserProfile: builder.mutation<any, { name: string; email: string }>({
      query: (data: any) => ({
        url: '/user/profile',
        method: 'PUT',
        data,
      }),
      invalidatesTags: ['User'],
    }),
  }),
});

// path, reducer, middleware
export const userReducerPath = userApi.reducerPath;
export const userReducer = userApi.reducer;
export const userMiddleware = userApi.middleware;

// action
export const { useGetUserProfileQuery, useUpdateUserProfileMutation } = userApi;
